import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Call911Warning = () => {
  return (
    <React.Fragment>
      <h1>
        <FontAwesomeIcon icon="exclamation-triangle" />
        &nbsp; STOP and call 911
      </h1>
      <p>
        If this person is in immediate danger, please stop filling out this form
        immediately, and call 911.
      </p>
      <p>
        You can return and file a complaint once the imminent threat to the
        victim has been addressed.
      </p>
    </React.Fragment>
  )
}
